var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04889 7.99999C3.04889 6.85999 3.97556 5.93332 5.11556 5.93332H7.78223V4.66666H5.11556C3.27556 4.66666 1.78223 6.15999 1.78223 7.99999C1.78223 9.83999 3.27556 11.3333 5.11556 11.3333H7.78223V10.0667H5.11556C3.97556 10.0667 3.04889 9.13999 3.04889 7.99999ZM5.78223 8.66666H11.1156V7.33332H5.78223V8.66666ZM11.7822 4.66666H9.11556V5.93332H11.7822C12.9222 5.93332 13.8489 6.85999 13.8489 7.99999C13.8489 9.13999 12.9222 10.0667 11.7822 10.0667H9.11556V11.3333H11.7822C13.6222 11.3333 15.1156 9.83999 15.1156 7.99999C15.1156 6.15999 13.6222 4.66666 11.7822 4.66666Z",
    fill: "#838489"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.dd288c8b8a6b007d76b6fe2f8f3775e1.svg";
export { ForwardRef as ReactComponent };